import 'axios';
import { useState, useEffect } from 'react';
import '@bugsnag/js';
import '@bugsnag/plugin-react';
import '../errors/index.js';
import { getBankHolidays, getCustomers, getSchools, getSchool, getSpaces, getSpace, getSchoolSites } from '../api/index.js';

// eslint-disable-next-line import/prefer-default-export
const useBankHolidays = () => {
  const [bankHolidays, setBankHolidays] = useState([]);
  useEffect(() => {
    getBankHolidays().then(data => {
      if (data.length > 0) {
        setBankHolidays(data);
      } else {
        setBankHolidays(null);
      }
    }).catch(err => console.log(err));
  }, []);
  return bankHolidays;
};

// eslint-disable-next-line import/prefer-default-export
const useCustomers = () => {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    getCustomers().then(setCustomers).catch(err => console.log(err));
  }, []);
  return customers;
};
const useSchools = () => {
  const [schools, setSchools] = useState([]);
  useEffect(() => {
    getSchools().then(schoolData => {
      setSchools(schoolData);
    }).catch(err => console.log(err));
  }, []);
  return schools;
};
const useCustomSchools = (pagination, page, limit, searchString) => {
  const [schools, setSchools] = useState({
    total: 0,
    data: []
  });
  useEffect(() => {
    const fetchCounter = setTimeout(() => {
      getSchools({
        pagination,
        page,
        limit,
        searchString
      }).then(schoolData => {
        setSchools(schoolData);
      }).catch(err => console.log(err));
    }, 500);
    return () => clearTimeout(fetchCounter);
  }, [page, limit, searchString, pagination]);
  return schools;
};
const useSchool = id => {
  const [school, setSchool] = useState([]);
  useEffect(() => {
    getSchool(id).then(setSchool).catch(err => console.log(err));
  }, [id]);
  return school;
};
const useSpaces = () => {
  const [spaces, setSpaces] = useState([]);
  useEffect(() => {
    getSpaces().then(spaceData => {
      setSpaces(spaceData);
    }).catch(err => console.log(err));
  }, []);
  return spaces;
};
const useCustomSpaces = (pagination, page, limit, searchString) => {
  const [spaces, setSpaces] = useState({
    total: 0,
    data: []
  });
  useEffect(() => {
    const fetchCounter = setTimeout(() => {
      getSpaces({
        pagination,
        page,
        limit,
        searchString
      }).then(spaceData => {
        setSpaces(spaceData);
      }).catch(err => console.log(err));
    }, 500);
    return () => clearTimeout(fetchCounter);
  }, [page, limit, searchString, pagination]);
  return spaces;
};
const useSpace = id => {
  const [space, setSpace] = useState({});
  useEffect(() => {
    getSpace(id).then(setSpace).catch(err => console.log(err));
  }, [id]);
  return space;
};
const useSchoolSites = id => {
  const [sites, setSite] = useState([]);
  useEffect(() => {
    getSchoolSites(id).then(setSite).catch(err => console.log(err));
  }, [id]);
  return sites;
};

// eslint-disable-next-line import/prefer-default-export
const useSteps = numberOfSteps => {
  const [stepIndex, setStepIndex] = useState(0);
  const isFirstStep = stepIndex === 0;
  const isLastStep = stepIndex === numberOfSteps - 1;
  const nextStep = () => setStepIndex(stepIndex + 1);
  const previousStep = () => setStepIndex(stepIndex - 1);
  const goToStep = index => setStepIndex(index);
  return {
    stepIndex,
    isFirstStep,
    isLastStep,
    nextStep,
    previousStep,
    goToStep
  };
};
export { useBankHolidays, useCustomSchools, useCustomSpaces, useCustomers, useSchool, useSchoolSites, useSchools, useSpace, useSpaces, useSteps };